import { defineComponent as a, computed as o, openBlock as i, createElementBlock as r, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "da7803de-9bc9-4def-bb00-176f235a1368" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#da7803de-9bc9-4def-bb00-176f235a1368)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h167v512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M345 0h167v512H345z"
}, null, -1), x = { fill: "none" }, b = ["r"], z = /* @__PURE__ */ a({
  __name: "fr",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), r("title", k, d(t.flagName), 1)) : f("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  z as default
};
//# sourceMappingURL=fr-568f0591.js.map
